// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TTrackSpecialPromoShowRequest,
  TTrackSpecialPromoShowModel,
  IMappers,
  TTrackSpecialPromoShowResponse,
  TTrackSpecialPromoShowResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createTrackSpecialPromoShowModel(
  parameters: TTrackSpecialPromoShowRequest,
): TTrackSpecialPromoShowModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'special-promos-exclusive',
    pathApi: '/v1/track-special-promo-show/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ITrackSpecialPromoShowOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TTrackSpecialPromoShowRequest;
}

export async function fetchTrackSpecialPromoShow<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ITrackSpecialPromoShowOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TTrackSpecialPromoShowResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createTrackSpecialPromoShowModel(parameters),
    config,
  )) as FetchResponse<TTrackSpecialPromoShowResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TTrackSpecialPromoShowResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TTrackSpecialPromoShowResponse>;
}
